import { render } from "./GenericBlock.vue?vue&type=template&id=fb03b448"
import script from "./GenericBlock.vue?vue&type=script&lang=js"
export * from "./GenericBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__